<script>
import AddApiKeyModal from "@/view/components/accounts/AddApiKeyModal.vue";
import {required, minLength, maxLength, alphaNum, email, sameAs} from "vuelidate/lib/validators";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";
import { dateFormatReadable } from "@/utils";
export default {
  name: "integrations",
  components: {
    AddApiKeyModal,
    DataTableSection
  },
  data() {
    return {
        form: {
            api_key: ""
        },
        item: null,
        tableDataParam: {
            getters: 'getEmailProviders',
            dispatchFunction: 'getEmailProviders',
            headers: [
                {
                    text: "Provider",
                    align: "left",
                    sortable: true,
                    value: "provider",
                    width: "150px"
                },
                { text: "API Key", align:"center",value: "api_key",width: "150px" },
                { text: "Date Created", value: "created",width: "150px" },
                { text: "Date Modified", value: "modified",width: "150px" },
                // { text: "Action", value: "action",sortable: false }
            ]
      },
      customRenderers: [
        {
          field: "api_key",
        },
        {
          field: "created",
        },
        {
          field: "modified",
        },
      ] 
    };
  },
  validations: {
    form : {
        api_key : {maxLength: maxLength(255)}
    }
  },
  async mounted() {

  },
  computed: {
  },
  watch: {
  },
  methods: {
    showUpdateApiModal(item){
        this.form.api_key = item.api_key;
    },
    async emailProviderRemove(item) {
        console.log(item);
    },
    handleModalClose() {

    },
    updateDate(d){
        return dateFormatReadable(d)
    }
  }
};
</script>

<template>
  <v-card>
    <!-- For Future functionality -->
    <!-- <v-row class="mb-5">
      <v-col cols="12" md="8">
        <v-btn class="ml-4" depressed tile v-b-modal.modal-add-api-key>
          <v-icon left> mdi-plus-box </v-icon> Add API Key
        </v-btn>
      </v-col>
    </v-row> -->
    <data-table-section
        :tableData="this.tableDataParam"
        :customRenderers="this.customRenderers"
        :isSelectEnabled="false"
        :setPerPage="5"
        ref="dataTableComponent"
      >
      <template v-slot:api_keyparams="{ item }">
        <v-btn
          text
          color="primary"
          @click="showUpdateApiModal(item)"
          v-b-modal.modal-add-api-key
        >
          {{ item.api_key }}
        </v-btn>
      </template>

      <template v-slot:createdparams="{ item }">
          {{ updateDate(item.created) }}
      </template>

      <template v-slot:modifiedparams="{ item }">
          {{ updateDate(item.modified) }}
      </template>


      <!-- <template disabled v-slot:actionparams="{ item }">
        <a href="#" @click.prevent="emailProviderRemove(item)">
          Delete
        </a>
      </template> -->
    </data-table-section>
    <add-api-key-modal
      @close="handleModalClose"
      :api_key="form.api_key">
    </add-api-key-modal>
  </v-card>
</template>

<style>
  .v-data-footer{
    justify-content: flex-end;
  }

  .v-menu__content {
    position: absolute;
    display: inline-block;
    max-width: 80%;
    overflow-y: auto;
    overflow-x: hidden;
    contain: content;
    will-change: transform;
    -webkit-box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
    border-radius: 4px;
  }
</style>